import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ContactUsService } from '../../services/contact-us.service';

import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {


    myControl = new FormControl();
    mobileForm = new FormGroup({
        phone: new FormControl("", [Validators.required])
    });
    options!: any[];
    filteredOptions!: Observable<any>;
    selectedOrganization!: any;
    form: any = {
        organization: {
            name: "",
            id: ""
        },
        mobileNumber: { number: "", countryCode: "", dialCode: "" },
        firstName: "",
        lastName: "",
        emailAddress: "",
        message:  ""
    };

    constructor(public contactService: ContactUsService, public common: CommonService,
        public authenticationService: AuthenticationService,
        private _activatedRoute: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {
        this.getAllAccounts();
    }
    private getAllAccounts() {
        this.authenticationService._getAllAccounts().subscribe((res: any) => {
            //console.log('Web/Register/getAllAccounts()', res);
            this.options = res;
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map((value: string) => this._filter(value)),
            );
        }, (err: any) => {
            console.error("Web/Register/getAllAccounts()", err);
        });
    }
    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.Name.toLowerCase().includes(filterValue));
    }
    getSelectedOrganization(option: any) {
        console.log("Web/Account/Register/getSelectedOrganization", option);
        this.selectedOrganization = option;
        this.form.organization.name = option.Name;
        this.form.organization.id = option.Id;
    }
    error_message: boolean = false;
    success_message: boolean = false;
    submit() {
        debugger;
        var obj = {
            FirstName: this.form.firstName,
            LastName: this.form.lastName,
            Email: this.form.emailAddress,
            MobileNumber: this.mobileForm.value.phone, 
            OrganizationName: this.form.organization.name,
            OrganizationSFID: this.form.organization.id,
            Message:this.form.message
        };
        this.contactService.submitAuthContactUs(obj).subscribe(
            (res: any) => {
                if (res.success) {
                    this.success_message = true;
                }
                else {
                    this.error_message = true;
                    console.error("submitAuthContactUs", res.error_message);
                }
            },
            (err: any) => {
                console.error("submitAuthContactUs", err);
            }
        );
    }
}
